import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Account from '../views/account/Account.vue';
import BadConnection from '../views/badconnection/BadConnection.vue';
import ChangePassword from '../views/change-password/ChangePassword.vue';
import Login from '../views/login/Login.vue';
import PlayListView from '../views/playlist/PlayListView.vue';
import PlaylistList from '../views/playlist/PlaylistList.vue';
import Programs from '../views/programs/Programs.vue';
import ReleasePage from '../views/release-page/ReleasePage.vue';
import ReleaseGuide from '../views/release/ReleaseGuide.vue';
import ReleaseMain from '../views/release/ReleaseMain.vue';
import ReleaseMusic from '../views/release/ReleaseMusic.vue';
import ReleaseVideo from '../views/release/ReleaseVideo.vue';
import ResetPassword from '../views/reset-password/ResetPassword.vue';
import Settings from '../views/settings/Settings.vue';
import SignUp from '../views/signup/SignUp.vue';
import AdminEducationSections from '../views/admin/AdminEducationSections.vue';
import AdminRoles from '../views/admin/AdminRoles.vue';
import AdminMediaUpload from '../views/admin/AdminMediaUpload.vue';
import AdminReleases from '../views/admin/AdminReleases.vue';
import AdminTests from '../views/admin/AdminTests.vue';
import Skills from '../views/skills/Skills.vue';
import Testing from '../views/testing/Testing.vue';
import Today from '../views/today/Today.vue';
import Users from '../views/users/Users.vue';
import PrivacyPolicy from '../views/privacy/PrivacyPolicy.vue';
import OfferSupplement from '../views/privacy/OfferSupplement.vue';
import EventsList from '../views/events/EventsList.vue';
import EventDetail from '../views/events/EventDetail.vue';
import EventPaymentSuccess from '../views/events/EventPaymentSuccess.vue';
import AdminEventsList from '../views/events/AdminEventsList.vue';
import AdminEventEdit from '../views/events/AdminEventEdit.vue';
import AdminEventRegistrations from '../views/events/AdminEventRegistrations.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/today',
    name: 'Today',
    component: Today,
    // children: [
    //   {
    //     path: '/today-workouts',
    //     name: 'TodayWorkouts',
    //     component: TodayWorkouts,
    //   },
    // ],
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/admin-roles',
    name: 'AdminRoles',
    component: AdminRoles
  },
  {
    path: '/admin-education-sections',
    name: 'AdminEducationSections',
    component: AdminEducationSections
  },
  {
    path: '/admin-media-upload',
    name: 'AdminMediaUpload',
    component: AdminMediaUpload
  },
  {
    path: '/admin-releases',
    name: 'AdminReleases',
    component: AdminReleases
  },
  {
    path: '/admin-testing',
    name: 'AdminTesting',
    component: AdminTests
  },
  {
    path: '/admin-video-upload',
    redirect: '/admin-media-upload'
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/badconnection',
    name: 'BadConnection',
    component: BadConnection
  },
  {
    path: '/programs',
    name: 'Programs',
    component: Programs
  },
  {
    path: '/release-page',
    name: 'ReleasePage',
    component: ReleasePage
  },
  {
    path: '/ReleaseMain',
    name: 'ReleaseMain',
    component: ReleaseMain,
    children: [
      {
        path: '/guide',
        name: 'ReleaseGuide',
        component: ReleaseGuide,
      },
      {
        path: '/video',
        name: 'ReleaseVideo',
        component: ReleaseVideo,
      },
      {
        path: '/music',
        name: 'ReleaseMusic',
        component: ReleaseMusic,
      },
    ],
  },
  {
    path: '/playlist-list',
    name: 'PlaylistList',
    component: PlaylistList
  },
  {
    path: '/playlist-view',
    name: 'PlayListView',
    component: PlayListView
  },
  {
    path: '/skills',
    name: 'Skills',
    component: Skills
  },
  {
    path: '/testing',
    name: 'Testing',
    component: Testing
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/offer-supplement',
    name: 'OfferSupplement',
    component: OfferSupplement
  },
  {
    path: '/events',
    name: 'EventsList',
    component: EventsList
  },
  {
    path: '/events/success',
    name: 'EventPaymentSuccess',
    component: EventPaymentSuccess
  },
  {
    path: '/events/:id',
    name: 'EventDetail',
    component: EventDetail
  },
  {
    path: '/admin-events',
    name: 'AdminEventsList',
    component: AdminEventsList
  },
  {
    path: '/admin-events/new',
    name: 'AdminEventNew',
    component: AdminEventEdit
  },
  {
    path: '/admin-events/:id/edit',
    name: 'AdminEventEdit',
    component: AdminEventEdit
  },
  {
    path: '/admin-events/:id/registrations',
    name: 'AdminEventRegistrations',
    component: AdminEventRegistrations
  },
  {
    path: '/admin-payments',
    name: 'AdminPayments',
    component: () => import('../views/admin/AdminPayments.vue')
  },
  {
    path: '/my-tickets',
    name: 'MyTickets',
    component: () => import('../views/events/MyTickets.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
